import { OFFICE_CLOSED } from '@/config/constants'

export const INITIAL_OFFICE_TIMING_INFO = {
	active: false,
	indicator: OFFICE_CLOSED,
	visible: false,
	officeHoursSet: false,
	lunchHoursSet: false,
}

export default function state() {
	return {
		officeOpenInfo: INITIAL_OFFICE_TIMING_INFO,

		alertSettingsPopup: {
			visible: false,
		},

		alertPreferences: {
			id: null,
			audio_alert_enabled: false,
			visual_alert_enabled: false,
			inactivity_threshold_minutes: 5,
			alert_sound: null,
			alert_color: 'orange',
		},

		/** First pointer gesture anywhere under App (before / after Manager mounts) */
		appUserInteractionReceived: false,
	}
}
